import MainLayout from "Layout/MainLayout";

export default function NotFound() {
  return (
    <MainLayout color="#222">
      <div className="notfound">
        <p>404 | page not found</p>
      </div>
    </MainLayout>
  );
}
